const abordagens = [
  'Análise do comportamento',
  'Análise Junguiana',
  'Behaviorismo',
  'Fenomenologia',
  'Gestalt',
  'Humanista',
  'Logoterapia',
  'Positiva',
  'Psicanálise',
  'Psicanálise Lacaniana',
  'Psicodinâmica',
  'Psicodrama',
  'Psicologia humanista',
  'Sistêmica',
  'Terapia cognitivo-comportamental (TCC)',
  'Transpessoal',
  'Psicologia socio-historica',
  'Psicodinâmica'
]

export default abordagens